import { useCardConfig } from '../../../providers/CardConfigProvider';
import {
  ProgramCardContainer,
  ProgramCardCvvContainer,
  ProgramCardCvvNumber,
  ProgramCardCvvTextContainer,
  ProgramCardCvvTitle,
  ProgramCardHologram,
  ProgramCardDescriptionContainer,
  ProgramCardRightPattern,
  ProgramCardStrip,
  ProgramCardStripsContainer,
  ProgramCardMagneticStrip,
  ProgramCardTopHollowContainer,
  CardSizeVairant,
  ProgramCardText,
  CARD_AUTHORIZED_SIGNRATURE_FONT_SIZE,
  TextContainer,
} from './CardComponents';

type Props = { variant?: CardSizeVairant };
function ProgramCardBack({ variant = CardSizeVairant.NORMAL }: Props) {
  const { physicalCardConfig } = useCardConfig();

  return (
    <ProgramCardContainer
      backgroundColor={physicalCardConfig.background}
      variant={variant}
    >
      <TextContainer>
        <ProgramCardTopHollowContainer
          hide={Boolean(physicalCardConfig.aboveMagneticPanelText)}
          variant={variant}
          color={physicalCardConfig.textColor}
        >
          {physicalCardConfig.aboveMagneticPanelText}
        </ProgramCardTopHollowContainer>
      </TextContainer>

      <ProgramCardMagneticStrip />

      <TextContainer>
        <ProgramCardText
          color={physicalCardConfig.textColor}
          variant={variant}
          left="5%"
          bottom="5%"
          lineHeight="140%"
          fontWeight={500}
        >
          Credit Card
        </ProgramCardText>
      </TextContainer>
      <ProgramCardHologram />

      <TextContainer>
        <ProgramCardText
          color={physicalCardConfig.textColor}
          variant={variant}
          fontSize={CARD_AUTHORIZED_SIGNRATURE_FONT_SIZE[variant].fontSize}
          left="4%"
          bottom="38%"
          fontWeight={700}
          textTransform="capitalize"
        >
          AUTHORIZED SIGNATURE
        </ProgramCardText>
      </TextContainer>

      <TextContainer>
        <ProgramCardDescriptionContainer
          hide={Boolean(physicalCardConfig.signaturePanelText)}
          variant={variant}
          color={physicalCardConfig.textColor}
        >
          {physicalCardConfig.signaturePanelText}
        </ProgramCardDescriptionContainer>
      </TextContainer>

      <ProgramCardRightPattern left="-60%" />
      <ProgramCardRightPattern left="-70%" />

      <ProgramCardCvvContainer>
        <ProgramCardStripsContainer>
          <ProgramCardStrip />
          <ProgramCardStrip />
          <ProgramCardStrip />
          <ProgramCardStrip />
          <ProgramCardStrip />
          <ProgramCardStrip />
        </ProgramCardStripsContainer>
        <ProgramCardCvvTextContainer>
          <ProgramCardCvvTitle variant={variant}>CVV</ProgramCardCvvTitle>
          <ProgramCardCvvNumber variant={variant}>123</ProgramCardCvvNumber>
        </ProgramCardCvvTextContainer>
      </ProgramCardCvvContainer>
    </ProgramCardContainer>
  );
}

export default ProgramCardBack;
